import _Object$keys from 'babel-runtime/core-js/object/keys';
/*
 * @Description: 悟空软件
 * @Author: 悟空
 * @Date: 2020-05-14 14:25:43
 * @LastEditTime: 2020-05-26 14:40:09
 * @LastEditors: yang
 */
import 'babel-polyfill';
import Vue from 'vue';

import 'normalize.css/normalize.css'; // A modern alternative to CSS resets


// 引入 CC301_TV
// import "./TV/jquery-1.8.3.min.js"
// import "./TV/qnviccub.js"
// import "./TV/qnvfunc.js"
// import "./TV/json2.js"
// import "./TV/deviceapi.js"

// 配置信息
import config from '@/config';
window.WKConfig = config;
Vue.prototype.WKConfig = config;

import ElementUI from 'element-ui';
Vue.use(ElementUI);
import { Message } from 'element-ui';
Vue.prototype.$message.success = function (msg) {
  return Message({
    message: msg,
    duration: 1500,
    type: 'success'
  });
};
Vue.prototype.$message.error = function (msg) {
  return Message({
    message: msg,
    duration: 1500,
    type: 'error'
  });
};
import 'element-ui/lib/theme-chalk/index.css';
import 'el-bigdata-table';

import '@/styles/index.scss'; // global css

import App from './App';
import router from './router';
import store from './store';

import cache from '@/utils/cache';
cache.loadingCache();

import '@/permission'; // permission control
import 'vue2-animate/dist/vue2-animate.min.css';

/** 事件传递 */
import VueBus from 'vue-bus';
Vue.use(VueBus);

/** 常用flex组件 */
import { Flexbox, FlexboxItem } from '@/components/Flexbox';
Vue.component('flexbox', Flexbox);
Vue.component('flexbox-item', FlexboxItem);
import XrAvatar from '@/components/XrAvatar';
Vue.component('xr-avatar', XrAvatar);

import FileUpload from '@/components/FileUpload/index.js';
Vue.use(FileUpload);
import WkFileSelect from '@/components/NewCom/WkFile/Select/main.js';
Vue.use(WkFileSelect);

import WkImport from '@/components/WkImport/main.js';
Vue.use(WkImport);

/** 懒加载图片 */
import VueSrc from './directives/src';
Vue.directive('src', VueSrc);

import * as filters from './filters'; // global filters
// 注册全局过滤器
_Object$keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});
import vueNumeralFilterInstaller from './filters/vueNumeralFilter';
Vue.use(vueNumeralFilterInstaller, { locale: 'chs' });

// 处理时间的过滤器
Vue.use(require('vue-moment'));
import moment from 'moment';
moment.locale('zh_cn');

// 限制数据数值
import inputLimit from './directives/inputLimit';
Vue.use(inputLimit);
// 自定义全局点击空白处组件
import clickoutside from './directives/clickoutside';
Vue.directive('clickoutside', clickoutside);
import elClickoutside from './directives/elClickoutside';
Vue.directive('elclickoutside', elClickoutside);

import empty from './directives/empty';
Vue.use(empty);
import debounce from './directives/clickDebounce';
Vue.use(debounce);

// 表情
import { emoji } from './utils/emoji';
import { Ws } from './ws/Ws';
import { sleep } from './utils';
Vue.prototype.emoji = emoji;

// 创建WebSocket实例
var socket = new Ws();
//const socket = new WebSocket('ws://106.52.82.80:7272');

// 监听连接打开事件
// socket.addEventListener('open', function(event) {
//   console.log('Connected to WebSocket server.');
// });

// 监听关闭事件
// socket.addEventListener('close', function(event) {
//   console.log('Disconnected from WebSocket server.');
// });

// 监听错误事件
// socket.addEventListener('error', function(error) {
//   console.error('WebSocket error:', error);
// });

// 监听接收到消息事件
// socket.addEventListener('message', function(event) {
//   const data = JSON.parse(event.data);
//   // 处理从服务器接收到的数据，比如存入Vuex store
// });

// 将WebSocket实例挂载到Vue原型上以便全局访问
Vue.prototype.$socket = socket.getInstance();

Vue.config.productionTip = false;

window.app = new Vue({
  el: '#app',
  router: router,
  store: store,
  data: {
    eventHub: new Vue()
  },
  render: function render(h) {
    return h(App);
  }
});